export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Create Your Account',
      description: 'Sign up in seconds and set up your personalized profile. Tell us about your preferences, and our AI will start learning what you love.',
      icon: 'ri-user-add-line',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      number: '02',
      title: 'Browse with AI Assistance',
      description: 'Use natural language search, visual recognition, or browse curated collections. Our AI understands your needs and shows you exactly what you\'re looking for.',
      icon: 'ri-search-eye-line',
      color: 'from-purple-500 to-pink-500'
    },
    {
      number: '03',
      title: 'Smart Checkout',
      description: 'Enjoy seamless, secure checkout with multiple payment options. Our AI optimizes shipping routes for faster delivery at the best price.',
      icon: 'ri-secure-payment-line',
      color: 'from-orange-500 to-red-500'
    },
    {
      number: '04',
      title: 'Track & Enjoy',
      description: 'Real-time tracking powered by AI logistics. Get accurate delivery predictions and proactive updates every step of the way.',
      icon: 'ri-truck-line',
      color: 'from-green-500 to-emerald-500'
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-indigo-50 px-4 py-2 rounded-full mb-4">
            <i className="ri-lightbulb-line text-indigo-600"></i>
            <span className="text-sm font-semibold text-indigo-600">HOW IT WORKS</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Your Journey to Smart Shopping
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Experience the future of e-commerce in four simple steps. Our AI-powered platform makes shopping effortless and enjoyable.
          </p>
        </div>

        <div className="grid lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-20 left-1/2 w-full h-0.5 bg-gradient-to-r from-indigo-200 to-purple-200 z-0"></div>
              )}
              <div className="relative z-10 text-center">
                <div className={`w-20 h-20 mx-auto mb-6 bg-gradient-to-br ${step.color} rounded-2xl flex items-center justify-center shadow-lg`}>
                  <i className={`${step.icon} text-white text-3xl`}></i>
                </div>
                <div className="text-5xl font-bold text-gray-200 mb-4">{step.number}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                <p className="text-gray-600 leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-3xl p-12">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                For Suppliers: Grow Your Business with AI
              </h3>
              <ul className="space-y-4">
                {[
                  'List products in minutes with AI-assisted descriptions',
                  'Get real-time analytics and sales insights',
                  'Automated inventory and order management',
                  'AI-powered pricing optimization',
                  'Access to millions of potential customers',
                  'Dedicated seller support and resources'
                ].map((item, index) => (
                  <li key={index} className="flex items-start space-x-3">
                    <div className="w-6 h-6 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <span className="text-gray-700 font-medium">{item}</span>
                  </li>
                ))}
              </ul>
              <button className="mt-8 px-8 py-4 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all font-semibold cursor-pointer whitespace-nowrap inline-flex items-center space-x-2">
                <span>Become a Seller</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
            <div>
              <img
                src="https://public.readdy.ai/ai/img_res/8bae3a224a019527e71dc7b0bed9df03.jpg"
                alt="Seller Dashboard"
                className="rounded-2xl shadow-2xl w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
